import { useNavigate } from "@tanstack/react-router";
import { Package, Users } from "lucide-react";
import { Text } from "../../../ui/components/Text";
import { Callout } from "../../../ui/components/Callout";
import { TabSwitcher } from "../../../ui/components/TabSwitcher";
import { useAuth } from "../../lib/auth/hooks";
import { useI18n } from "../../lib/i18n";
import { SmartLinkUsersTab } from "./SmartLinkUsersTab";
import { SmartLinkProductsTab } from "./SmartLinkProductsTab";
import * as pageStyles from "../users/UsersListPage.css";
import * as s from "./SmartLinkListPage.css";

export type SmartLinkTab = "users" | "products";

export function SmartLinkListPage({ tab }: { tab: SmartLinkTab }) {
  const { accessToken } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();

  const token = accessToken ?? (typeof localStorage !== "undefined" ? localStorage.getItem("access_token") : null);

  if (!token) {
    return (
      <div className={pageStyles.page}>
        <Callout variant="error">{t("pro.system.smartLink.signInRequired")}</Callout>
      </div>
    );
  }

  return (
    <div className={pageStyles.page}>
      <div className={pageStyles.pageHeader}>
        <Text level="h1" color="text" weight="bold">
          {t("pro.system.smartLink.title")}
        </Text>
      </div>

      <div className={s.tabs}>
        <TabSwitcher
          aria-label={t("pro.system.smartLink.tabs.label")}
          value={tab}
          onChange={(next) =>
            void navigate({ to: "/system/smart-link", search: { tab: next as SmartLinkTab }, replace: true })
          }
          tabs={[
            { value: "users", label: t("pro.system.smartLink.tabs.users"), icon: <Users size={14} /> },
            { value: "products", label: t("pro.system.smartLink.tabs.products"), icon: <Package size={14} /> },
          ]}
        />
      </div>

      {tab === "products" ? <SmartLinkProductsTab token={token} /> : <SmartLinkUsersTab token={token} />}
    </div>
  );
}
